/**
 * groups — wspólne słownictwo kartotek niosących pole systemowe `groups text[]` (klasyfikacja
 * rekordu do filtrowania listy, WIELE na rekord). JEDNO źródło prawdy dla mapy kartoteka →
 * kod słownika grup, współdzielone przez:
 *  - apps/api (`lib/records/groups.ts`) — walidacja przynależności + wykonawca akcji grupowych,
 *  - apps/admin (modal „Zmień zbiorczo", edytor akcji własnych) — picker grup (`GroupsInput`).
 *
 * Kartoteka niebędąca kluczem tej mapy NIE ma grup (np. dokumenty, towary). NIE mylić z „osią
 * kategorii" (jedna na rekord, steruje layoutem — `record-categories.ts`).
 */

export const GROUPS_DICTIONARY_BY_KARTOTEKA = {
  contractors: 'contractor_groups',
  employees: 'employee_groups',
  users: 'user_groups',
  companies: 'company_groups',
  contractor_contacts: 'contractor_contact_groups',
} as const;

export type GroupsKartotekaKey = keyof typeof GROUPS_DICTIONARY_BY_KARTOTEKA;

/** Czy kartoteka ma pole grup (i słownik grup). */
export function kartotekaHasGroups(key: string): key is GroupsKartotekaKey {
  return Object.prototype.hasOwnProperty.call(GROUPS_DICTIONARY_BY_KARTOTEKA, key);
}
